module.exports = __webpack_public_path__ + "static/media/banner-imagethrd.eb33d975.jpg";